import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useHistory } from 'react-router-dom';
import { validarSesion } from '../tokens/useToken';


export const useReportShippingDownloads = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [appliedActionType, setAppliedActionType] = useState("");
    const [reportLogs, setReportLogs] = useState([]);

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    
    const [indicators, setIndicators] = useState({
        total_printed: 0,
        total_sent: 0,
        total_actions: 0
    });

    const [searchTerm, setSearchTerm] = useState("");
    const [tableFilters, setTableFilters] = useState({
        nim: "",
        patient: "",
        patient_type: "",
        date: "",
        user: "",
        action: "",
        email: ""
    });

    //#region ALERT GLOBAL 
    const showToastAlert = (type = "info", title = "", message = "") => {
        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };
    //#endregion

    const handleTableFilter = (e) => {
        const { name, value } = e.target;

        setTableFilters(prev => ({
            ...prev,
            [name]: value
        }));

        setCurrentPage(1);
    };

    const clearTableFilters = () => {
        setTableFilters({
            nim: "",
            patient: "",
            patient_type: "",
            date: "",
            user: "",
            action: "",
            email: ""
        });

        setSearchTerm("");
        setCurrentPage(1);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        mDateRange1: moment().startOf("month").format("YYYY-MM-DD"),
        mDateRange2: moment().endOf("month").format("YYYY-MM-DD"),
        mActionType: ""
    });


    const {
        mDateRange1,
        mDateRange2,
        mActionType
    } = formValues;

    useEffect(() => {
        const startMonth = moment()
            .startOf("month")
            .format("YYYY-MM-DD");

        const endMonth = moment()
            .endOf("month")
            .format("YYYY-MM-DD");

        getReportLogExam(true,`${startMonth}/${endMonth}`);
    }, []);


    
    // #region FILTERS  
    

    const getReportLogs = (e) => {

        if (e) {
            e.preventDefault();
        }

        if (mDateRange1 && mDateRange2) {

            const start = moment(mDateRange1);
            const end = moment(mDateRange2);

            if (end.isBefore(start)) {
                showToastAlert(
                    "warning",
                    "Atención",
                    "La fecha final no puede ser menor a la fecha inicial"
                );
                return;
            }

            const diffDays = end.diff(start,'days');

            if (diffDays > 365) {
                showToastAlert(
                    "warning",
                    "Atención",
                    "No puede seleccionar un rango mayor a un año"
                );
                return;
            }
        }

        const fromDate = mDateRange1
            ? moment(mDateRange1).format("YYYY-MM-DD")
            : moment().startOf("month").format("YYYY-MM-DD");

        const toDate = mDateRange2
            ? moment(mDateRange2).format("YYYY-MM-DD")
            : moment().endOf("month").format("YYYY-MM-DD");
        
        let query = `${fromDate}/${toDate}`;

        if ( mActionType !== "" && mActionType !== "0") {
            query += `?action_type=${mActionType}`;
        }
        setAppliedActionType(mActionType || "");
        setSearchTerm("");
        setCurrentPage(1);
        getReportLogExam(true, query);
    };

    //#endregion


    const getReportLogExam = async ( _search = false, _filter = "") => {
        setLoading(true);
        try {
            let response = null;

            if (_search === false) {
                response = await handleRequest("GET", "Reports/GetReportPrintSend/", "Reporte" );
            } else {
                response = await handleRequest( "GET", `Reports/GetReportPrintSend/${_filter}`, "Reporte" );
            }

            if (response) {
                setIndicators({
                    total_printed: response.total_printed || 0,
                    total_sent: response.total_sent || 0,
                    total_actions: response.total_actions || 0
                });

                setReportLogs(
                    Array.isArray(response.rows) ? response.rows : []
                );

            } else {
                setIndicators({ total_printed: 0, total_sent: 0, total_actions: 0});
                setReportLogs([]);
            }

        } catch (error) {
            setIndicators({
                total_printed: 0,
                total_sent: 0,
                total_actions: 0
            });
            setReportLogs([]);

        } finally {
            setLoading(false);
        }
    };


    //#region FILTER CLEAR

    const handleClean = () => {

        const startMonth = moment()
            .startOf("month")
            .format("YYYY-MM-DD");

        const endMonth = moment()
            .endOf("month")
            .format("YYYY-MM-DD");

        handleUpdateValues({
            mDateRange1: startMonth,
            mDateRange2: endMonth,
            mActionType: ""
        });

        setAppliedActionType("");
        setSearchTerm("");

        setTableFilters({
            nim: "",
            patient: "",
            date: "",
            user: "",
            action: "",
            email: ""
        });

        setCurrentPage(1);
        getReportLogExam(true, `${startMonth}/${endMonth}`);
    };

    //#endregion


   //#region SEARCH

    const handleSearch = (e) => {
        setSearchTerm( e.target.value);
        setCurrentPage(1);
    };

    //#endregion

    //#region REGISTRE FILTERS
    const filteredLogs = useMemo(() => {
        const generalSearch = searchTerm.trim().toUpperCase();
        const nimFilter = tableFilters.nim.trim().toUpperCase();
        const patientFilter = tableFilters.patient.trim().toUpperCase();
        const patientTypeFilter = tableFilters.patient_type;
        const dateFilter = tableFilters.date.trim().toUpperCase();
        const userFilter = tableFilters.user.trim().toUpperCase();
        const actionFilter = tableFilters.action.trim().toUpperCase();
        const emailFilter = tableFilters.email.trim().toUpperCase();

        return reportLogs
            .map(row => {

                const nim = String(row.nim || "").toUpperCase();
                const patient = String(row.patient || "").toUpperCase();
                const originalHistory = Array.isArray(row.history)
                    ? row.history
                    : [];

                // FILTROS DEL NIM Y PACIENTE
                if (nimFilter && !nim.includes(nimFilter)) {
                    return null;
                }

                if (patientFilter && !patient.includes(patientFilter)) {
                    return null;
                }

                if (patientTypeFilter && row.patient_type !== patientTypeFilter) {
                    return null;
                }

                let filteredHistory = originalHistory.filter(item => {

                    const date = String(item.date || "").toUpperCase();
                    const user = String(item.user || "").toUpperCase();
                    const action = String(item.action || "").toUpperCase();
                    const email = String(item.email_sent_to || "").toUpperCase();

                    if (dateFilter && !date.includes(dateFilter)) {
                        return false;
                    }

                    if (userFilter && !user.includes(userFilter)) {
                        return false;
                    }

                    if (actionFilter && action !== actionFilter) {
                        return false;
                    }

                    if (emailFilter && !email.includes(emailFilter)) {
                        return false;
                    }

                    return true;
                });

                const hasHistoryFilters =
                    dateFilter ||
                    userFilter ||
                    actionFilter ||
                    emailFilter;

                if (hasHistoryFilters && filteredHistory.length === 0) {
                    return null;
                }

                if (generalSearch) {

                    const matchMain =
                        nim.includes(generalSearch) ||
                        patient.includes(generalSearch);

                    const matchHistory = filteredHistory.some(item => {

                        const date = String(item.date || "").toUpperCase();
                        const user = String(item.user || "").toUpperCase();
                        const action = String(item.action || "").toUpperCase();
                        const email = String(item.email_sent_to || "").toUpperCase();

                        return (
                            date.includes(generalSearch) ||
                            user.includes(generalSearch) ||
                            action.includes(generalSearch) ||
                            email.includes(generalSearch)
                        );
                    });

                    if (!matchMain && !matchHistory) {
                        return null;
                    }

                    if (!matchMain) {
                        filteredHistory = filteredHistory.filter(item => {

                            const date = String(item.date || "").toUpperCase();
                            const user = String(item.user || "").toUpperCase();
                            const action = String(item.action || "").toUpperCase();
                            const email = String(item.email_sent_to || "").toUpperCase();

                            return (
                                date.includes(generalSearch) ||
                                user.includes(generalSearch) ||
                                action.includes(generalSearch) ||
                                email.includes(generalSearch)
                            );
                        });
                    }
                }

                return {
                    ...row,
                    history: filteredHistory
                };

            })
            .filter(Boolean);

    }, [reportLogs, searchTerm, tableFilters]);

    //#region PAGINATION

    const totalPages = Math.max( 1,
        Math.ceil( filteredLogs.length / rowsPerPage)
    );


    const paginatedLogs = useMemo(() => {
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;

        return filteredLogs.slice(startIndex, endIndex);

    }, [filteredLogs, currentPage, rowsPerPage ]);


    useEffect(() => {

        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [ currentPage, totalPages]);



    const handleChangePage = (page) => {
        if ( page < 1 || page > totalPages) {
            return;
        }
        setCurrentPage(page);
    };


    const handleRowsPerPage = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    //#endregion


    //#region EXCEL
    const exportExcel = () => {
        if (!filteredLogs || filteredLogs.length === 0) {
            showToastAlert(
                "error",
                "",
                "No hay datos para exportar"
            );
            return;
        }

        const aoa = [
            [
                '#',
                'NIM',
                'Paciente',
                'Impresiones',
                'Envíos',
                'Total',
                'Fecha',
                'Usuario',
                'Método de entrega',
                'Correo'
            ]
        ];

        const merges = [];

        filteredLogs.forEach((row, rowIndex) => {

            const history = Array.isArray(row.history)
                ? row.history
                : [];

            // Si no tiene historial
            if (history.length === 0) {
                aoa.push([
                    rowIndex + 1,
                    row.nim || '',
                    row.patient || '',
                    row.total_printed || 0,
                    row.total_sent || 0,
                    row.total_actions || 0,
                    '',
                    '',
                    '',
                    ''
                ]);

                return;
            }

            // Fila donde comienza este NIM
            const startRow = aoa.length;

            history.forEach((item, historyIndex) => {

                const isFirst = historyIndex === 0;

                aoa.push([
                    isFirst ? rowIndex + 1 : '',
                    isFirst ? row.nim || '' : '',
                    isFirst ? row.patient || '' : '',
                    isFirst ? row.total_printed || 0 : '',
                    isFirst ? row.total_sent || 0 : '',
                    isFirst ? row.total_actions || 0 : '',

                    item.date || '',
                    item.user || '',
                    item.action === "Envío"
                        ? "Correo electrónico"
                        : item.action || '',

                    item.email_sent_to || ''
                ]);
            });

            if (history.length > 1) {

                const endRow = startRow + history.length - 1;

                // #
                merges.push({
                    s: { r: startRow, c: 0 },
                    e: { r: endRow, c: 0 }
                });

                // NIM
                merges.push({
                    s: { r: startRow, c: 1 },
                    e: { r: endRow, c: 1 }
                });

                // Paciente
                merges.push({
                    s: { r: startRow, c: 2 },
                    e: { r: endRow, c: 2 }
                });

                // Impresiones
                merges.push({
                    s: { r: startRow, c: 3 },
                    e: { r: endRow, c: 3 }
                });

                // Envíos
                merges.push({
                    s: { r: startRow, c: 4 },
                    e: { r: endRow, c: 4 }
                });

                // Total
                merges.push({
                    s: { r: startRow, c: 5 },
                    e: { r: endRow, c: 5 }
                });
            }
        });

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);

        worksheet['!merges'] = merges;

        worksheet['!cols'] = [
            { wch: 6 },   // #
            { wch: 20 },  // NIM
            { wch: 35 },  // Paciente
            { wch: 14 },  // Impresiones
            { wch: 10 },  // Envíos
            { wch: 10 },  // Total
            { wch: 20 },  // Fecha
            { wch: 38 },  // Usuario
            { wch: 22 },  // Método
            { wch: 35 }   // Correo
        ];

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            'Impresiones_Envios'
        );

        const excelBuffer = XLSX.write(
            workbook,
            {
                bookType: 'xlsx',
                type: 'array'
            }
        );

        const dataBlob = new Blob(
            [excelBuffer],
            {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        );

        const fileName =
            `Reporte_Impresiones_Envios_${moment().format("YYYY-MM-DD")}.xlsx`;

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    //#endregion

    const handleRequest = async (method, methodUrl, nameMethod,body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions,methodUrl);

        if (response.code === 200) {
            return response.data;
        }

        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }

        else if (response.code === 500) {
            showToastAlert(
                "error",
                nameMethod,
                "Ocurrió un error en el servidor"
            );
        }

        else {
            showToastAlert(
                "warning",
                nameMethod,
                response.data?.msg || response.msg || "Ocurrió un problema"
            );
        }
        return null;
    };


    return {

        //? FORM
        mDateRange1,
        mDateRange2,
        mActionType,
        handleInputChange,

        //? REPORT
        reportLogs,
        filteredLogs,
        paginatedLogs,
        loading,

        //? INDICATORS
        indicators,

        //? SEARCH
        searchTerm,
        handleSearch,

        //? FILTERS
        getReportLogs,
        handleClean,
        tableFilters,
        handleTableFilter,
        clearTableFilters,
        appliedActionType,

        //? PAGINATION
        currentPage,
        totalPages,
        rowsPerPage,
        handleChangePage,
        handleRowsPerPage,

        //? EXCEL
        exportExcel,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,

    };
};